export default __webpack_public_path__ + "static/media/screen7.d85c674f.jpg";